export default __webpack_public_path__ + "static/media/manage_providers_challenges.40dcbe63.svg";